<template>
  <div id="app" class="mx-auto max-w-xl relative min-h-screen">
    <div class="fixed top-0 left-0 w-full p-2 text-white bg-primary z-50" v-if="isUpdating">
      New Version available. Update in {{ countdown }} seconds
    </div>
    <LegalReminderComp />
    <!-- <template v-if="true">
      <EmergencyConfirmation />
    </template> -->
    <router-view></router-view>
  </div>
</template>

<script>
  import { location } from "@/states/location";
  import { log } from "@/states/log";
  import { Dialog } from "vant";
  import LegalReminderComp from "@/components/LegalLayoutComp.vue";
  // import EmergencyConfirmation from "./components/Emergency/EmergencyConfirmation.vue";
  export default {
    name: "App",
    components: {
      LegalReminderComp
      // EmergencyConfirmation
    },
    data: () => ({
      currentVersion: null,
      location,
      interval: null,
      isUpdating: false,
      countdown: 10
    }),
    mounted() {
      this.checkVersion();
      this.interval = setInterval(this.checkVersion, 2 * (60 * 1000));
      const count = window.localStorage.getItem("tl_mounted");
      if (count) {
        window.localStorage.setItem("tl_mounted", parseInt(count) + 1);
      } else {
        window.localStorage.setItem("tl_mounted", 1);
      }

      if (this.location.isMocked)
        Dialog.alert({
          title: "Akun anda dikunci",
          message: "Anda melanggar aturan penggunaan aplikasi. Harap hubungi IT untuk informasi lebih lanjut.",
          confirmButtonText: "Dimengerti."
        }).then(() => {
          localStorage.removeItem("token");
          this.$router.push("/");
        });

      const orig = {
        log: console.log,
        warn: console.warn,
        error: console.error,
        info: console.info
      };

      const capture =
        (type) =>
        (...args) => {
          const message = args.map((a) => (typeof a === "object" ? JSON.stringify(a) : String(a))).join(" ");
          log.data.push({ type, message });

          // Keep logs under 1000
          if (log.data.length > 1000) log.data.shift();

          orig[type](...args); // Still print to original console
        };

      console.log = capture("log");
      console.warn = capture("warn");
      console.error = capture("error");
      console.info = capture("info");
    },
    watch: {
      location: {
        handler() {
          if (this.location.isMocked)
            Dialog.alert({
              title: "Akun anda dikunci",
              message: "Anda melanggar aturan penggunaan aplikasi. Harap hubungi IT untuk informasi lebih lanjut.",
              confirmButtonText: "Dimengerti."
            }).then(() => {
              localStorage.removeItem("token");
              this.$router.push("/");
            });
        },
        deep: true
      }
    },
    methods: {
      async checkVersion() {
        try {
          const res = await fetch("/version.json", { cache: "no-store" });
          const { version } = await res.json();

          if (!this.currentVersion) {
            this.currentVersion = version;
          } else if (this.currentVersion !== version) {
            this.isUpdating = true;
            console.log("New version detected, reloading...");
            clearInterval(this.interval);
            setInterval(() => {
              this.countdown--;
              if (this.countdown <= 0) {
                clearInterval(this.interval);
                window.location.reload(true); // force reload from server
              }
            }, 1000); // 60 seconds countdown
            // window.location.reload(true); // force reload from server
          }
        } catch (e) {
          console.error("Version check failed:", e);
        }
      }
    }
  };
</script>

<style>
  body {
    --ky-primary: #132855; /* Primary color */
    --ky-secondary: #ffb867; /* Secondary color */
    --ky-accent: #ff7676; /* Accent color */
    --ky-tertiary: #6bffff; /* Tertiary color */
    --ky-warning: #ffcd4b; /* Warning color */
    --ky-danger: #ff4b4b; /* Danger color */
    --ky-success: #4baa4b; /* Success color */
  }

  /* body .bg-primary {
    background-color: var(--ky-primary) !important;
  }
  body .bg-secondary {
    background-color: var(--ky-secondary) !important;
  }
  body .bg-accent {
    background-color: var(--ky-accent) !important;
  }
  body .bg-tertiary {
    background-color: var(--ky-tertiary) !important;
  }
  body .bg-warning {
    background-color: var(--ky-warning) !important;
  }
  body .bg-danger {
    background-color: var(--ky-danger) !important;
  }
  body .bg-success {
    background-color: var(--ky-success) !important;
  }
  body .text-primary {
    color: var(--ky-primary) !important;
  }
  body .text-secondary {
    color: var(--ky-secondary) !important;
  }
  body .text-accent {
    color: var(--ky-accent) !important;
  }
  body .text-tertiary {
    color: var(--ky-tertiary) !important;
  }
  body .text-warning {
    color: var(--ky-warning) !important;
  }
  body .text-danger {
    color: var(--ky-danger) !important;
  } */
</style>
